var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M16 9H2M9 16L2 9l7-7"})));
}

ArrowLeft.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
